// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebaseConfig: {
  apiKey: "AIzaSyAJkQszB3lQPeYpoe1td2rPhwK5BaIZG5s",
  authDomain: "testphishing-bca59.firebaseapp.com",
  projectId: "testphishing-bca59",
  storageBucket: "testphishing-bca59.firebasestorage.app",
  messagingSenderId: "840091156487",
  appId: "1:840091156487:web:f3fd345abc394c17772aa2"
},
  uriServices: {
    users: {
      login: ""
    }
  }

};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
